module.exports = __webpack_public_path__ + "static/media/4.e99019fc.svg";